import FJConstant from '../constants/FJConstant.js';
import FJEvent from './FJEvent.js';
import { FJ_EVENT_TYPE } from '../constants/FJEvenTypeConstant.js';

let _playType = null; // 播放类型
let _playSpeechId = null; // 播放的语音id
let _playStatus = FJConstant.IDLE; // 播放状态 FJConstant.IDLE(空闲， 停止) FJConstant.PLAYING(播放中) FJConstant.PAUSED(暂停) FJConstant.WAITING(等待播放)
let _isEnterPlayMode = false; // 是否进入播放模式

const FJTTSPlayStore = {
    setPlayType: function (type) {
        _playType = type;
    },

    getPlayType: function () {
        return _playType;
    },

    setPlaySpeechId: function (speechId) {
        _playSpeechId = speechId;
    },

    setPlayStatus: function (status) {
        _playStatus = status;
    },

    setIsEnterPlayMode: function (isEnter) {
        _isEnterPlayMode = isEnter;
    },

    enterPlayMode: function (id) {
        this.setPlaySpeechId(id);
        this.setIsEnterPlayMode(true);
    },

    enterGlobalPlay: function () {
        this.setPlayType(FJConstant.GLOBAL_PLAY);
        this.setIsEnterPlayMode(true);
    },

    exitPlayMode: function () {
        this.setPlayType(null);
        this.setPlaySpeechId(null);
        this.setIsEnterPlayMode(false);
    },

    play: function (id) {
        if (!_isEnterPlayMode) {
            // 如果当前没有进入播放模式，则不进行播放
            return;
        }

        if (_playSpeechId !== id) {
            // 如果当前播放的语音id与传入的语音id不一致，则不进行播放
            return;
        }

        FJEvent.dispatch(FJ_EVENT_TYPE.PLAY_CURRENT_SPEECH_BY_ID, id);
    },

    globalPlay: function (id) {
        FJEvent.dispatch(FJ_EVENT_TYPE.PLAY_CURRENT_SPEECH_BY_ID, id);
    },
};

export default FJTTSPlayStore;
